// CheckingPriceBadge - Pulsing placeholder shown on search cards while
// the progressive live-price refresh is still awaiting responses from one
// or more suppliers linked to that master AND no usable price is available
// yet. Resolves to either a real "from £X.XX" or a definitive "-" once
// every relevant supplier has responded.

export interface CheckingPriceBadgeProps {
  className?: string
}

export function CheckingPriceBadge({ className = '' }: CheckingPriceBadgeProps) {
  return (
    <span
      className={`inline-block whitespace-nowrap text-[11px] bg-amber-50 text-amber-600 px-2 py-0.5 rounded-md font-medium animate-pulse ${className}`}
    >
      Checking price…
    </span>
  )
}
